/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/AppActiveUser/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    url: "/clientes",
    name: "Clientes",
    slug: "customers", 
    icon: "UsersIcon",
  },
  {
    url: "/solicitacao",
    name: "Solicitação de Peças",
    slug: "solicitacao", 
    icon: "CheckIcon",
    //tag: "3",
    //tagColor: "warning",
  },

  {
    url: "/produtos",
    name: "Produtos",
    slug: "products", 
    icon: "ArchiveIcon",
    //tag: "3",
    //tagColor: "warning",
  },
  {
    url: "/faturas",
    name: "Faturas",
    slug: "invoices", 
    icon: "DollarSignIcon",
  },
  {
  header: 'Contratos',
  icon: 'ListIcon',
  items: [
    {
      name: "Contratos",
      slug: "contratos",
      icon: "FileTextIcon",
      submenu: [
        {
          url: "/ativos",
          name: "Ativos Locação",
          slug: "permanentAssets",
        },
        {
          url: "/revenda",
          name: "Revenda",
          slug: "permanentAssets",
        },
        {
          url: "/contratos",
          name: "Contratos",
          slug: "permanentAssets",
        },
      ],
    },
  ]
  },
  {
    header: 'Orçamentos',
    icon: 'ListIcon',
    items: [
      {
        name: "Orçamentos",
        slug: "Orçamentos",
        icon: "CheckCircleIcon",
        submenu: [
          {
            url: "/orcamentos/novo-orcamento",
            name: "Novo",
            slug: "Novo Orçamento",
          },
          {
             url: "/orcamentos",
            name: "Listar Orçamentos",
            slug: "orçamentos",
          },
        ],
      },
    ]
    }, 
  {
    header: 'Pedidos',
    icon: 'ListIcon',
    items: [
      {
        name: "Equipamentos",
        slug: "email",
        icon: "PrinterIcon",
        submenu: [
          {
            url: "/equipamentos/novo-pedido",
            name: "Novo",
            slug: "ecommerce-shop",
            i18n: "Novo",
          },
          {
            url: "/equipamentos",
            name: "Visualizar",
            slug: "ecommerce-shop",
            i18n: "Visualizar",
          },
          {
            url: "/equipamentos/busca-avancada",
            name: "Busca Avançada",
            slug: "ecommerce-shop",
            i18n: "Busca Avançada",
          },
          {
            url: "/equipamentos/concluidos",
            name: "Concluídos",
            slug: "ecommerce-shop",
            i18n: "Concluídos",
          },
        ]
      },
      {
        name: "Suprimentos",
        slug: "email",
        icon: "RefreshCcwIcon",
        submenu: [
          {
            url: "/suprimentos/novo-pedido",
            name: "Novo",
            slug: "ecommerce-shop",
            i18n: "Novo",
          },
          {
            url: "/suprimentos",
            name: "Visualizar",
            slug: "ecommerce-shop",
            i18n: "Visualizar",
          },
          {
            url: "/suprimentos/busca-avancada",
            name: "Busca Avançada",
            slug: "ecommerce-shop",
            i18n: "Busca Avançada",
          },
          {
            url: "/suprimentos/concluidos",
            name: "Concluídos",
            slug: "ecommerce-shop",
            i18n: "Concluídos",
          },
        ]
      },
      {
        name: "Peças",
        slug: "email",
        icon: "SettingsIcon",
        submenu: [
          {
            url: "/pecas/novo-pedido",
            name: "Novo",
            slug: "ecommerce-shop",
            i18n: "Novo",
          },
          {
            url: "/pecas",
            name: "Visualizar",
            slug: "ecommerce-shop",
            i18n: "Visualizar",
          },
          {
            url: "/pecas/busca-avancada",
            name: "Busca Avançada",
            slug: "ecommerce-shop",
            i18n: "Busca Avançada",
          },
          {
            url: "/pecas/concluidos",
            name: "Concluídos",
            slug: "ecommerce-shop",
            i18n: "Concluídos",
          },
        ]
      },
      {
        name: "Suprimentos Locação",
        slug: "email",
        icon: "TruckIcon",
        submenu: [
          {
            url: "/suprimentos-locacao/novo-pedido",
            name: "Novo",
            slug: "ecommerce-shop",
            i18n: "Novo",
          },
          {
            url: "/suprimentos-locacao",
            name: "Visualizar",
            slug: "ecommerce-shop",
            i18n: "Visualizar",
          },
          {
            url: "/suprimentos-locacao/busca-avancada",
            name: "Busca Avançada",
            slug: "ecommerce-shop",
            i18n: "Busca Avançada",
          },
          {
            url: "/suprimentos-locacao/concluidos",
            name: "Concluídos",
            slug: "ecommerce-shop",
            i18n: "Concluídos",
          },
        ]
      },
      {
        name: "Mão de Obra",
        slug: "email",
        icon: "CheckSquareIcon",
        submenu: [
          {
            url: "/mao-de-obra/novo-pedido",
            name: "Novo",
            slug: "ecommerce-shop",
            i18n: "Novo",
          },
          {
            url: "/mao-de-obra",
            name: "Visualizar",
            slug: "ecommerce-shop",
            i18n: "Visualizar",
          },
          {
            url: "/mao-de-obra/concluidos",
            name: "Concluídos",
            slug: "ecommerce-shop",
            i18n: "Concluídos",
          },
        ]
      },
      {
        name: "Locação",
        slug: "email",
        icon: "EditIcon",
        submenu: [
          {
            url: "/locacao/novo-pedido",
            name: "Novo",
            slug: "ecommerce-shop",
            i18n: "Novo",
          },
          {
            url: "/locacao",
            name: "Visualizar",
            slug: "ecommerce-shop",
            i18n: "Visualizar",
          },
          {
            url: "/locacao/concluidos",
            name: "Concluídos",
            slug: "ecommerce-shop",
            i18n: "Concluídos",
          },
        ]
      },
      {
        name: "Ouro",
        slug: "email",
        icon: "TrelloIcon",
        submenu: [
          {
            url: "/ouro/novo-pedido",
            name: "Novo",
            slug: "ecommerce-shop",
            i18n: "Novo",
          },
          {
            url: "/ouro",
            name: "Visualizar",
            slug: "ecommerce-shop",
            i18n: "Visualizar",
          },
          {
            url: "/ouro/concluidos",
            name: "Concluídos",
            slug: "ecommerce-shop",
            i18n: "Concluídos",
          },
        ]
      },
      {
        name: "Revisão Equipamentos",
        slug: "email",
        icon: "AlertCircleIcon",
        submenu: [
          {
            url: "/revisao-equipamentos/novo-pedido",
            name: "Novo",
            slug: "ecommerce-shop",
            i18n: "Novo",
          },
          {
            url: "/revisao-equipamentos",
            name: "Visualizar",
            slug: "ecommerce-shop",
            i18n: "Visualizar",
          },
          {
            url: "/revisao-equipamentos/busca-avancada",
            name: "Busca Avançada",
            slug: "ecommerce-shop",
            i18n: "Busca Avançada",
          },
          {
            url: "/revisao-equipamentos/concluidos",
            name: "Concluídos",
            slug: "ecommerce-shop",
            i18n: "Concluídos",
          },
        ]
      },
      {
        name: "Relatórios",
        slug: "Relatórios",
        icon: "FileTextIcon",
        submenu: [
          {
            url: "/equipamentos-relatorio",
            name: "Equipamentos",
            slug: "Equipamentos",
            i18n: "Equipamentos",
          },
          {
            url: "/suprimentos-relatorio",
            name: "Suprimentos",
            slug: "Suprimentos",
            i18n: "Suprimentos",
          },
          {
            url: "/pecas-relatorio",
            name: "Peças",
            slug: "Peças",
            i18n: "Peças",
          },
          {
            url: "/mao-de-obra-relatorio",
            name: "Mão de Obra",
            slug: "Mão de Obra",
            i18n: "Mão de Obra",
          },
        ] 
      }
    ],
  },
  {
    header: 'Comissões',
    items: [
      {
        url: "/comissoes",
        name: "Comissões",
        slug: "Comissões",
        icon: "FileTextIcon",
      },
      
    ]
  }
]


